import { render, staticRenderFns } from "./m-block-image-cropper.vue?vue&type=template&id=08e78839&scoped=true&lang=pug"
import script from "./m-block-image-cropper.vue?vue&type=script&lang=js"
export * from "./m-block-image-cropper.vue?vue&type=script&lang=js"
import style0 from "./m-block-image-cropper.vue?vue&type=style&index=0&id=08e78839&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e78839",
  null
  
)

export default component.exports